import { useNavigate } from "react-router-dom";
import { Car, ChevronLeft, AlertCircle, FileCode } from "lucide-react";

/**
 * Long-Term Parking Page - NOT CONNECTED YET
 * Shell component showing required API endpoint
 */
export default function CommercialLongTerm() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50" data-testid="commercial-long-term">
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate("/admin/commercial")} className="p-2 hover:bg-gray-100 rounded-lg"><ChevronLeft className="w-5 h-5" /></button>
          <div><h1 className="text-xl font-bold text-gray-900">Long-Term Parking</h1><p className="text-sm text-gray-500">Extended stay parking management</p></div>
        </div>
      </div>

      <div className="p-6">
        <div className="max-w-2xl mx-auto">
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-8 text-center">
            <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
              <AlertCircle className="w-8 h-8 text-amber-600" />
            </div>
            <h2 className="text-xl font-bold text-amber-800 mb-2">Not Connected Yet</h2>
            <p className="text-amber-700 mb-6">The Long-Term Parking API has not been implemented yet.</p>
            
            <div className="bg-white rounded-lg p-4 text-left border border-amber-200">
              <div className="flex items-center gap-2 mb-3">
                <FileCode className="w-5 h-5 text-amber-600" />
                <span className="font-semibold text-amber-800">Required Endpoint</span>
              </div>
              <code className="block bg-gray-100 p-3 rounded text-sm text-gray-700 font-mono">
                GET /api/commercial/long-term
              </code>
              <p className="mt-3 text-sm text-gray-600">
                This endpoint should return long-term parking records with fields:
              </p>
              <ul className="mt-2 text-sm text-gray-600 list-disc list-inside space-y-1">
                <li>booking_id, customer_name, reg_number</li>
                <li>site_id, check_in, check_out</li>
                <li>daily_rate_pence, total_amount_pence</li>
                <li>status, payment_status</li>
                <li>notes, created_at</li>
              </ul>
            </div>

            <div className="mt-6 flex items-center justify-center gap-4">
              <button onClick={() => navigate("/admin/commercial")} className="px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-white">
                Back to Dashboard
              </button>
              <button onClick={() => navigate("/admin/commercial/payments")} className="px-4 py-2 text-sm bg-amber-600 text-white rounded-lg hover:bg-amber-700">
                View Payments Instead
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
